import React, { useState } from 'react';

const INITIAL_TICKETS = [
  { id:'TK-001', subject:'Unable to post player request', contact:'James Morris', company:'Arsenal FC', priority:'High',   status:'Open',        category:'Bug',     created:'Apr 3, 2026', updated:'Apr 3, 2026 14:22', assignee:'David Olawale', messages:[{ from:'James Morris', body:"Hi, I'm trying to post a player request but the form keeps erroring out.", time:'Apr 3, 2026 13:00', type:'contact' },{ from:'David Olawale', body:'Hi James, thanks for reaching out. Can you share a screenshot of the error?', time:'Apr 3, 2026 14:22', type:'agent' }] },
  { id:'TK-002', subject:'Scout not receiving evaluation alerts', contact:'Alex Aldridge', company:'Colorado Rapids', priority:'Medium', status:'In Progress', category:'Support',  created:'Apr 2, 2026', updated:'Apr 2, 2026 16:00', assignee:'Amira Sule', messages:[{ from:'Alex Aldridge', body:'I submitted 3 evaluations but haven\'t received any confirmation emails.', time:'Apr 2, 2026 15:30', type:'contact' }] },
  { id:'TK-003', subject:'Payment not processed for evaluation', contact:'Emma Thompson',  company:'Man City',       priority:'High',   status:'Open',        category:'Billing',  created:'Apr 1, 2026', updated:'Apr 1, 2026 10:00', assignee:'Habeeb Habeeb', messages:[{ from:'Emma Thompson', body:'We were charged twice for the same evaluation. Please refund the duplicate.', time:'Apr 1, 2026 09:55', type:'contact' }] },
  { id:'TK-004', subject:'How to connect scout to club?',        contact:'Fatou Diop',    company:'—',              priority:'Low',    status:'Closed',      category:'Question', created:'Mar 30, 2026', updated:'Mar 30, 2026 12:00', assignee:'Kweku Mensah', messages:[{ from:'Fatou Diop', body:'I want to connect my profile to a club. How do I do this?', time:'Mar 30, 2026 11:00', type:'contact' },{ from:'Kweku Mensah', body:'Hi Fatou! You can connect to a club by going to your Scout Profile and clicking "Connect to Club". Let me know if you need further help!', time:'Mar 30, 2026 11:45', type:'agent' },{ from:'Fatou Diop', body:'Got it, thank you!', time:'Mar 30, 2026 12:00', type:'contact' }] },
  { id:'TK-005', subject:'API key not working in production',    contact:'Habeeb Habeeb', company:'TransferExpo',   priority:'High',   status:'In Progress', category:'Bug',     created:'Apr 3, 2026', updated:'Apr 3, 2026 09:00', assignee:'Habeeb Habeeb', messages:[{ from:'Habeeb Habeeb', body:'The production API key returns 401 even with correct headers.', time:'Apr 3, 2026 09:00', type:'contact' }] },
];

const priorityBadge = p => ({ High:'badge badge-red', Medium:'badge badge-amber', Low:'badge badge-gray' })[p] || 'badge badge-gray';
const statusBadge   = s => ({ Open:'badge badge-red', 'In Progress':'badge badge-amber', Closed:'badge badge-green' })[s] || 'badge badge-gray';
const categoryColor = c => ({ Bug:'#ff4d4d', Support:'#4fc3f7', Billing:'#f5a623', Question:'#8a9a97' })[c] || '#8a9a97';

export default function Tickets({ toast }) {
  const [tickets, setTickets]   = useState(INITIAL_TICKETS);
  const [selected, setSelected] = useState(null);
  const [filter, setFilter]     = useState('All');
  const [search, setSearch]     = useState('');
  const [reply, setReply]       = useState('');
  const [creating, setCreating] = useState(false);
  const [newTicket, setNewTicket] = useState({ subject:'', contact:'', priority:'Medium', category:'Support' });

  const ticket = tickets.find(t=>t.id===selected);

  const filtered = tickets.filter(t=>{
    const matchFilter = filter==='All' || t.status===filter || t.priority===filter || t.category===filter;
    const matchSearch = !search || `${t.subject} ${t.contact} ${t.company}`.toLowerCase().includes(search.toLowerCase());
    return matchFilter && matchSearch;
  });

  const sendReply = () => {
    if (!reply.trim()) return;
    setTickets(prev=>prev.map(t=>t.id===selected?{...t,status:'In Progress',updated:new Date().toLocaleString('en-GB',{day:'numeric',month:'short',year:'numeric',hour:'2-digit',minute:'2-digit'}),messages:[...t.messages,{from:'Habeeb Habeeb',body:reply,time:new Date().toLocaleString('en-GB',{day:'numeric',month:'short',year:'numeric',hour:'2-digit',minute:'2-digit'}),type:'agent'}]}:t));
    setReply('');
    toast?.('Reply sent');
  };

  const closeTicket = id => {
    setTickets(prev=>prev.map(t=>t.id===id?{...t,status:'Closed'}:t));
    toast?.('Ticket closed');
  };

  const createTicket = () => {
    if (!newTicket.subject || !newTicket.contact) { toast?.('Fill in subject and contact','warning'); return; }
    const t = { id:`TK-00${tickets.length+1}`, ...newTicket, company:'—', status:'Open', created:new Date().toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'}), updated:new Date().toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'}), assignee:'Habeeb Habeeb', messages:[] };
    setTickets(prev=>[t,...prev]);
    setCreating(false); setNewTicket({ subject:'', contact:'', priority:'Medium', category:'Support' });
    toast?.('Ticket created');
  };

  if (ticket) {
    return (
      <div>
        <button className="btn btn-ghost" style={{ marginBottom:16,fontSize:13 }} onClick={()=>setSelected(null)}>← Back to tickets</button>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 280px', gap:20 }}>
          <div>
            <div className="card" style={{ marginBottom:16 }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:16 }}>
                <div>
                  <div style={{ fontSize:11, color:'var(--text-dim)', marginBottom:4 }}>{ticket.id}</div>
                  <h2 style={{ fontFamily:'var(--font-display)', fontSize:18, fontWeight:500, color:'var(--text-primary)', marginBottom:8 }}>{ticket.subject}</h2>
                  <div style={{ display:'flex', gap:6 }}>
                    <span className={priorityBadge(ticket.priority)}>{ticket.priority}</span>
                    <span className={statusBadge(ticket.status)}>{ticket.status}</span>
                    <span style={{ padding:'3px 8px', borderRadius:99, fontSize:11, background:`${categoryColor(ticket.category)}22`, color:categoryColor(ticket.category) }}>{ticket.category}</span>
                  </div>
                </div>
                {ticket.status !== 'Closed' && (
                  <button className="btn btn-ghost" style={{ fontSize:12 }} onClick={()=>closeTicket(ticket.id)}>Mark as closed</button>
                )}
              </div>

              {/* Messages */}
              <div style={{ display:'flex', flexDirection:'column', gap:14, marginBottom:20 }}>
                {ticket.messages.map((m,i)=>(
                  <div key={i} style={{ display:'flex', gap:12, flexDirection:m.type==='agent'?'row-reverse':'row' }}>
                    <div className="avatar" style={{ width:32, height:32, fontSize:11, flexShrink:0, background:m.type==='agent'?'rgba(167,244,50,0.15)':'rgba(79,195,247,0.15)', color:m.type==='agent'?'var(--accent)':'#4fc3f7' }}>
                      {m.from.split(' ').map(n=>n[0]).join('').slice(0,2)}
                    </div>
                    <div style={{ maxWidth:'75%' }}>
                      <div style={{ display:'flex', gap:8, alignItems:'baseline', marginBottom:4, flexDirection:m.type==='agent'?'row-reverse':'row' }}>
                        <span style={{ fontSize:12, fontWeight:600, color:'var(--text-primary)' }}>{m.from}</span>
                        <span style={{ fontSize:11, color:'var(--text-dim)' }}>{m.time}</span>
                      </div>
                      <div style={{ padding:'10px 14px', borderRadius:10, background:m.type==='agent'?'rgba(167,244,50,0.08)':'var(--bg-input)', fontSize:13, color:'var(--text-primary)', lineHeight:1.6, border:`1px solid ${m.type==='agent'?'rgba(167,244,50,0.2)':'var(--border)'}` }}>
                        {m.body}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Reply box */}
              {ticket.status !== 'Closed' && (
                <div>
                  <textarea className="search-input" rows={4} placeholder="Write a reply..." value={reply} onChange={e=>setReply(e.target.value)} style={{ resize:'none', fontFamily:'var(--font-body)', marginBottom:10 }} />
                  <div style={{ display:'flex', gap:8 }}>
                    <button className="btn btn-primary" onClick={sendReply}>Send reply</button>
                    <button className="btn btn-ghost" onClick={()=>closeTicket(ticket.id)}>Reply & close</button>
                  </div>
                </div>
              )}
              {ticket.status === 'Closed' && (
                <div style={{ textAlign:'center', padding:'16px', color:'var(--text-dim)', fontSize:13, background:'var(--bg-input)', borderRadius:8 }}>This ticket is closed</div>
              )}
            </div>
          </div>

          {/* Sidebar */}
          <div className="card" style={{ alignSelf:'flex-start' }}>
            <div className="card-title" style={{ marginBottom:14 }}>Ticket details</div>
            {[['ID',ticket.id],['Contact',ticket.contact],['Company',ticket.company],['Assignee',ticket.assignee],['Created',ticket.created],['Updated',ticket.updated]].map(([k,v])=>(
              <div key={k} style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'1px solid var(--border)', fontSize:13 }}>
                <span style={{ color:'var(--text-dim)', fontSize:11 }}>{k}</span>
                <span style={{ color:'var(--text-primary)' }}>{v}</span>
              </div>
            ))}
            <div style={{ marginTop:14 }}>
              <label style={{ fontSize:11, color:'var(--text-dim)', display:'block', marginBottom:6 }}>Reassign to</label>
              <select className="search-input" style={{ fontSize:12 }} onChange={e=>{ setTickets(prev=>prev.map(t=>t.id===ticket.id?{...t,assignee:e.target.value}:t)); toast?.('Ticket reassigned'); }}>
                {['Habeeb Habeeb','Amira Sule','David Olawale','Kweku Mensah'].map(u=><option key={u}>{u}</option>)}
              </select>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Open tickets</div><div className="stat-value" style={{ color:'#ff4d4d' }}>{tickets.filter(t=>t.status==='Open').length}</div><div className="stat-sub">Needs attention</div></div>
        <div className="stat-card"><div className="stat-label">In progress</div><div className="stat-value" style={{ color:'#f5a623' }}>{tickets.filter(t=>t.status==='In Progress').length}</div><div className="stat-sub">Being handled</div></div>
        <div className="stat-card"><div className="stat-label">Closed today</div><div className="stat-value">{tickets.filter(t=>t.status==='Closed').length}</div><div className="stat-sub stat-up">Resolved</div></div>
        <div className="stat-card"><div className="stat-label">High priority</div><div className="stat-value" style={{ color:'#ff4d4d' }}>{tickets.filter(t=>t.priority==='High'&&t.status!=='Closed').length}</div><div className="stat-sub">Urgent</div></div>
      </div>

      <div className="toolbar">
        <input className="search-input" placeholder="Search tickets..." value={search} onChange={e=>setSearch(e.target.value)} />
        <button className="btn btn-primary" onClick={()=>setCreating(true)}>+ New ticket</button>
      </div>

      <div className="filter-pills">
        {['All','Open','In Progress','Closed','High','Bug','Billing','Support'].map(f=>(
          <button key={f} className={`pill ${filter===f?'active':''}`} onClick={()=>setFilter(f)}>{f}</button>
        ))}
      </div>

      {creating && (
        <div className="card" style={{ marginBottom:16 }}>
          <div className="card-header"><span className="card-title">New ticket</span><button className="btn btn-ghost" style={{ fontSize:12 }} onClick={()=>setCreating(false)}>✕</button></div>
          <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
              <div><label style={{ fontSize:11, color:'var(--text-muted)', display:'block', marginBottom:5 }}>Subject *</label><input className="search-input" value={newTicket.subject} onChange={e=>setNewTicket(p=>({...p,subject:e.target.value}))} placeholder="Issue summary" /></div>
              <div><label style={{ fontSize:11, color:'var(--text-muted)', display:'block', marginBottom:5 }}>Contact *</label><input className="search-input" value={newTicket.contact} onChange={e=>setNewTicket(p=>({...p,contact:e.target.value}))} placeholder="Contact name" /></div>
              <div><label style={{ fontSize:11, color:'var(--text-muted)', display:'block', marginBottom:5 }}>Priority</label><select className="search-input" value={newTicket.priority} onChange={e=>setNewTicket(p=>({...p,priority:e.target.value}))}>{['High','Medium','Low'].map(x=><option key={x}>{x}</option>)}</select></div>
              <div><label style={{ fontSize:11, color:'var(--text-muted)', display:'block', marginBottom:5 }}>Category</label><select className="search-input" value={newTicket.category} onChange={e=>setNewTicket(p=>({...p,category:e.target.value}))}>{['Bug','Support','Billing','Question'].map(x=><option key={x}>{x}</option>)}</select></div>
            </div>
            <div style={{ display:'flex', gap:8 }}><button className="btn btn-primary" onClick={createTicket}>Create ticket</button><button className="btn btn-ghost" onClick={()=>setCreating(false)}>Cancel</button></div>
          </div>
        </div>
      )}

      <div className="card" style={{ padding:0 }}>
        <div className="card-header" style={{ padding:'16px 20px', borderBottom:'1px solid var(--border)' }}>
          <span className="card-title">All tickets</span>
          <span style={{ fontSize:12, color:'var(--text-dim)' }}>{filtered.length} tickets</span>
        </div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>ID</th><th>Subject</th><th>Contact</th><th>Category</th><th>Priority</th><th>Assignee</th><th>Updated</th><th>Status</th></tr></thead>
            <tbody>
              {filtered.map(t=>(
                <tr key={t.id} style={{ cursor:'pointer' }} onClick={()=>setSelected(t.id)}>
                  <td style={{ color:'var(--text-dim)', fontSize:12 }}>{t.id}</td>
                  <td style={{ fontWeight:500 }}>{t.subject}</td>
                  <td style={{ color:'var(--text-muted)', fontSize:12 }}>{t.contact}</td>
                  <td><span style={{ padding:'3px 8px', borderRadius:99, fontSize:11, background:`${categoryColor(t.category)}22`, color:categoryColor(t.category) }}>{t.category}</span></td>
                  <td><span className={priorityBadge(t.priority)}>{t.priority}</span></td>
                  <td style={{ fontSize:12, color:'var(--text-muted)' }}>{t.assignee}</td>
                  <td style={{ fontSize:11, color:'var(--text-dim)' }}>{t.updated}</td>
                  <td><span className={statusBadge(t.status)}>{t.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
